import React, { useEffect, useState } from "react";
import { Title } from "../../../../stories/Title/Title";
import Close from "../../../../images/Close.svg";
import { Button } from "../../../../stories/Button/Button";
import { Label } from "../../../../stories/Label/Label";
import Input from "../../../../stories/Input/Input";
import EditTiptapEditor from "../../../../styles/EditTipTapEditor";
import StarterKit from "@tiptap/starter-kit";
import HardBreak from "@tiptap/extension-hard-break";

import { Extension, useEditor } from "@tiptap/react";
import TextAlign from "@tiptap/extension-text-align";
import Color from "@tiptap/extension-color";
import TextStyle from "@tiptap/extension-text-style";
import BulletList from "@tiptap/extension-bullet-list";
import Document from "@tiptap/extension-document";
import ListItem from "@tiptap/extension-list-item";
import OrderedList from "@tiptap/extension-ordered-list";
import Paragraph from "@tiptap/extension-paragraph";
import Text from "@tiptap/extension-text";
import { Operation } from "../../../../utils/Enum.types";
import {
  handleFormEvent,
  toInputStandardDate,
  toIsoDate,
} from "../../../../utils/UtilFunctions";
import { IObjectKeys } from "../../../../utils/formTypes";
import { msgType } from "../../../../utils/types";
import {
  EMPTY_STRING,
  emptyFunc,
  emptyMessage,
  TEN_ROWS,
} from "../../../../utils/constants";
import { AddCaseStudy, UpdateCaseStudy } from "./queries/mutations";
import {
  AddCaseStudyData,
  AddCaseStudyVar,
  CaseStudiesOrderField,
  CaseStudyNode,
  UpdateCaseStudyData,
  UpdateCaseStudyVar,
} from "./queries/types";
import { useLazyQuery, useMutation } from "@apollo/client";
import useUrlParams from "../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import { GetCaseStudies, getCaseStudyByNodeId } from "./queries/query";
import { nodeVar, OrderDirection } from "../../../../utils/commonQueryTypes";
import { Keys } from "../../../../utils/Enum.keys";
import MessageModal from "../../../../customComponents/MessageModal";
import { handleUploadAndDownloadFile } from "../../../../utils/Upload";
import { getDownloadUrl } from "../../../../utils/DownloadFile";
import axios from "axios";
import LoadingModal from "../../../pages/LoadingModal";
import CaseTypeAutocomplete from "./common/CaseTypeAutocomplete";
import useToken from "../../../../customHooks/useToken";
interface Props {
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
  caseStudyID: number;
  operation: Operation;
}

export interface FormData extends IObjectKeys {
  title: string;
  startDate: string;
  endDate: string;
  caseType: string;
}
const Add = ({ setModal, caseStudyID, operation }: Props) => {
  const [comment, setComment] = useState("");

  const [editSelectedFiles, setEditSelectedFiles] = useState<File[]>([]);
  const [message, setMessage] = useState<msgType>(emptyMessage);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [progress, setProgress] = useState(0);
  const [formData, setFormData] = useState<FormData>({
    title: "",
    startDate: "",
    endDate: "",
    caseType: "",
  });

  const { customer_id } = useUrlParams();

  const { user_details } = useLoggedInUserDetails();

  const [GetCaseStudy, { data }] = useLazyQuery<
    { node: CaseStudyNode },
    nodeVar
  >(getCaseStudyByNodeId);

  const [CreateCaseStudy, { loading }] = useMutation<
    AddCaseStudyData,
    AddCaseStudyVar
  >(AddCaseStudy, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [Update, { loading: UpdateLoading }] = useMutation<
    UpdateCaseStudyData,
    UpdateCaseStudyVar
  >(UpdateCaseStudy, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const CustomEnterExtension = Extension.create({
    name: "customEnter",

    addKeyboardShortcuts() {
      return {
        Enter: (e) => {
          const saveBtn = document.getElementsByClassName(
            "storybook-button--save"
          );

          if (saveBtn.length) {
            (saveBtn[0] as HTMLButtonElement).focus();
          }
          // Do custom stuff here
          return true; // Prevent default Enter behavior
        },
      };
    },
  });
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        // prevent default behavior of Enter creating a paragraph if you want only hardBreak
        hardBreak: false,
      }),
      HardBreak.configure({
        keepMarks: true,
      }),
      Document,
      Paragraph,
      Text,
      BulletList,
      OrderedList,
      ListItem,
      TextAlign.configure({
        types: ["heading", "paragraph"],
      }),
      TextStyle,
      Color,
      CustomEnterExtension,
    ],
    editorProps: {
      handleKeyDown(view, event) {
        if (event.key === "Enter" && event.shiftKey && editor) {
          event.preventDefault(); // prevent new paragraph
          editor.commands.setHardBreak();
          return true; // prevent default behavior
        }
        return false;
      },
    },
    onUpdate: ({ editor }) => {
      // Get HTML content and store in state
      setComment(editor.getHTML());
    },
    content: comment,
  });

  const formJson = [
    {
      labelName: "Title",
      inputName: "title",
      dataType: "text",
    },
    {
      labelName: "Case Type",
      inputName: "caseType",
      dataType: "text",
    },
    {
      labelName: "Start Date",
      inputName: "startDate",
      dataType: "date",
    },
    {
      labelName: "End Date",
      inputName: "endDate",
      dataType: "date",
    },
  ];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleValueChange = (newValue: string) => {
    setFormData((prev) => ({
      ...prev,
      caseType: newValue, // store object, not just string
    }));
  };


  // useEffect(() => {
  //   if(editor)
  //   {
  //     editor.commands.
  //   }
  // }, []);

  const handleSubmit = async () => {
    let filename = "";
    if (customer_id) {
      if (editSelectedFiles) {
        filename = editSelectedFiles
          .map((file, index) => {
            return `${customer_id}/caseStudies/${file.name}`;
          })
          .join(";");
      }
      if (operation === Operation.CREATE) {
        try {
          const response = await CreateCaseStudy({
            variables: {
              customerID: customer_id,
              user_details,
              input: {
                title: formData.title,
                startDate: toIsoDate(formData.startDate),
                endDate: toIsoDate(formData.endDate),
                synopsis: comment,
                documents: filename,
                caseType: formData.caseType,
              },
            },
            refetchQueries: [
              {
                query: GetCaseStudies,
                variables: {
                  after: null,
                  first: 50,
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: CaseStudiesOrderField.CREATED_AT,
                  },
                  name: EMPTY_STRING,
                  customerID: customer_id,
                  empID: user_details.id,
                },
              },
            ],
          });
          if (response.data && response.data.AddCaseStudy) {
            const uploadFilePromise = Promise.all([
              ...editSelectedFiles.map((f, index) => {
                const fileExt = f?.name.split(".").pop();
                return handleUploadAndDownloadFile(
                  f!,
                  `${customer_id}/caseStudies/${response.data?.AddCaseStudy.id}_${index}.${fileExt}`,
                  setProgress,
                  false
                );
              }),
            ]);
            Promise.all([uploadFilePromise]).then(([sendMsgData]) => {
              if (sendMsgData) {
                setEditSelectedFiles([]);
                setMessage({
                  flag: true,
                  message: "Case Study Added Successfully",
                  operation: Operation.CREATE,
                });
              }
            });
          }
        } catch (err) {
          console.error(err);
        }
      } else {
        try {
          const response = await Update({
            variables: {
              caseStudyID,
              user_details,
              input: {
                documents: filename,
                synopsis: comment,
                endDate: toIsoDate(formData.endDate),
                startDate: toIsoDate(formData.startDate),
                title: formData.title,
                caseType: formData.caseType,
              },
            },
            refetchQueries: [
              {
                query: GetCaseStudies,
                variables: {
                  after: null,
                  first: 50,
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: CaseStudiesOrderField.CREATED_AT,
                  },
                  name: EMPTY_STRING,
                  customerID: customer_id,
                  empID: user_details.id,
                },
              },
            ],
          });
          if (response.data && response.data.UpdateCaseStudy) {
            const uploadFilePromise = Promise.all([
              ...editSelectedFiles.map((f, index) => {
                const fileExt = f?.name.split(".").pop();
                return handleUploadAndDownloadFile(
                  f!,
                  `${customer_id}/caseStudies/${response.data?.UpdateCaseStudy.id}_${index}.${fileExt}`,
                  setProgress,
                  false
                );
              }),
            ]);
            Promise.all([uploadFilePromise]).then(([sendMsgData]) => {
              if (sendMsgData) {
                setEditSelectedFiles([]);
                setMessage({
                  flag: true,
                  message: "Case Study Updated Successfully",
                  operation: Operation.CREATE,
                });
              }
            });
          }
        } catch (err) {
          console.error(err);
        }
      }
    }
  };

  const handleClear = () => {
    setFormData({
      title: "",
      startDate: "",
      endDate: "",
      caseType: "",
    });
    setComment("");
    setEditSelectedFiles([]);
    if (editor) editor.commands.clearContent();
  };

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      handleClear();
      setModal(false);
    }
    setMessage(emptyMessage);
  };

  useEffect(() => {
    if (operation === Operation.UPDATE && caseStudyID) {
      GetCaseStudy({
        variables: {
          id: caseStudyID,
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setFormData({
            endDate: toInputStandardDate(data.node.endDate),
            startDate: toInputStandardDate(data.node.startDate),
            title: data.node.title,
            caseType: data.node.caseType,
          });
          if (editor) editor.commands.setContent(data.node.synopsis);
        }
      });
    }
  }, [caseStudyID, GetCaseStudy, data, editor, operation]);

  useEffect(() => {
    const fetchData = async () => {
      setOpenAddModal(true);
      if (data && data.node.documents) {
        const files = data.node.documents.split(";");

        let index = 0;
        for (const f of files) {
          const ext = f.split(".").pop();

          const filename = `${customer_id}/caseStudies/${data.node.id}_${index}.${ext}`;
          const ers = await getDownloadUrl(filename, false);

          const blob = await axios
            .get(ers, { responseType: "blob" })
            .then((response) => {
              return new File([response.data], `attachement_${index}.${ext}`, {
                type: response.data.type,
              });
            });
          if (blob.size > 0) {
            setOpenAddModal(false);
          }
          setEditSelectedFiles((prev) => [...prev, blob]);
          index++;
        }
      } else {
        setOpenAddModal(false);
      }
    };
    fetchData();
  }, [data, customer_id]);

  return (
    <>
      <form className="add-case-study">
        <div className="add-case-study__title">
          <Title>
            {`${operation === Operation.CREATE ? "Add" : "Update"}`} PMU-Traffic
            Engineering Studies
          </Title>
          <img
            src={Close}
            alt=""
            onClick={() => setModal(false)}
            className="modal-close-icon"
          />
        </div>
        <div className="add-case-study__block">
       
            <div className="add-case-study__block--flex">
              {formJson.map(({ labelName, dataType, inputName }, index) => {
                if (inputName === "caseType") {
                  return (
                    <div key={inputName} className="label-grid">
                      <Label>{labelName}</Label>
                      <CaseTypeAutocomplete
                        clearFunction={emptyFunc}
                        value={formData[inputName]}
                        onChange={(e) => {
                          handleValueChange(e);
                        }}
                        name={inputName}
                        type={dataType}
                      />
                    </div>
                  );
                } else
                  return (
                    <div key={index} className="label-grid">
                      <Label>{labelName}</Label>
                      <Input
                        type={dataType}
                        name={inputName}
                        onChange={handleChange}
                        autoFocus={index === 0}
                        value={formData[inputName]}
                        onKeyDown={(e) => {
                          if (index === formJson.length - 1) {
                            if (e.key === Keys.ENTER) {
                              e.preventDefault();
                              if (editor) editor.commands.focus();
                            }
                          } else {
                            handleFormEvent(e);
                          }
                        }}
                      />
                    </div>
                  );
              })}
              <Label>Synopsis</Label>
            </div>
    

          <div className="add-case-study__editor">
            <EditTiptapEditor
              commentState={{ comment, setComment }}
              editor={editor}
              filesState={{ editSelectedFiles, setEditSelectedFiles }}
            />
          </div>
        </div>
        <Button
          mode="save"
          loading={loading || UpdateLoading}
          onClick={handleSubmit}
        />
        <Button mode="clear" loading={loading || UpdateLoading} />
        <Button
          mode="cancel"
          loading={loading || UpdateLoading}
          onClick={() => setModal(false)}
        />
      </form>
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal flag={openAddModal} />
    </>
  );
};

export default Add;
